import {
    LogoWrapper,
    LogoImg,
} from './style';

export default () => {
    return (
        <LogoWrapper>
            <LogoImg src={'assets/icons/logo.webp'} />
        </LogoWrapper>
    );
}